export const CACHE_HEADER = 'x-axios-cache';
